import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["workspace_id"],
  _excluded2 = ["workspaceId", "couponId"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { APIClient } from '../misc/APIClient';
export var CouponAPI = /*#__PURE__*/function (_APIClient) {
  function CouponAPI() {
    _classCallCheck(this, CouponAPI);
    return _callSuper(this, CouponAPI, arguments);
  }
  _inherits(CouponAPI, _APIClient);
  return _createClass(CouponAPI, [{
    key: "find",
    value: function find(_ref) {
      var workspace_id = _ref.workspace_id,
        query = _objectWithoutProperties(_ref, _excluded);
      return this.client.get("/v3/workspaces/".concat(workspace_id, "/coupons"), {
        params: query
      }).then(this._data);
    }
  }, {
    key: "get",
    value: function get(id, params) {
      return this.client.get("/v3/coupons/".concat(id), {
        params: params
      }).then(this._data);
    }
  }, {
    key: "getCouponByCode",
    value: function getCouponByCode(code, workspaceId) {
      return this.client.get("/v3/workspaces/".concat(workspaceId, "/coupons/").concat(code)).then(this._data);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.client.post("/v3/coupons", data).then(this._data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.client.patch("/v3/coupons/".concat(id), data).then(this._data);
    }
  }, {
    key: "remove",
    value: function remove(id) {
      return this.client.delete("/v3/coupons/".concat(id)).then(this._data);
    }
  }]);
}(APIClient);
export var BillingAPI = /*#__PURE__*/function (_APIClient2) {
  function BillingAPI() {
    _classCallCheck(this, BillingAPI);
    return _callSuper(this, BillingAPI, arguments);
  }
  _inherits(BillingAPI, _APIClient2);
  return _createClass(BillingAPI, [{
    key: "getMemberBillingProfile",
    value: function getMemberBillingProfile(workspaceId, userId) {
      return this.client.get("/v3/workspaces/".concat(workspaceId, "/billing-profiles/").concat(userId)).then(this._data);
    }
  }, {
    key: "getTeamBillingProfile",
    value: function getTeamBillingProfile(teamId) {
      return this.client.get("/v3/teams/".concat(teamId, "/billing-profile")).then(this._data);
    }
  }, {
    key: "updateMemberBillingProfile",
    value: function updateMemberBillingProfile(workspaceId, data, userId) {
      return this.client.patch("/v3/workspaces/".concat(workspaceId, "/billing-profiles/").concat(userId), data).then(this._data);
    }
  }, {
    key: "updateTeamBillingProfile",
    value: function updateTeamBillingProfile(teamId, data) {
      return this.client.patch("/v3/teams/".concat(teamId, "/billing-profile"), data).then(this._data);
    }
  }, {
    key: "addBillingMethod",
    value: function addBillingMethod(data) {
      return this.client.post("/v3/billing-methods", data).then(this._data);
    }
  }, {
    key: "removeBillingMethod",
    value: function removeBillingMethod(billingMethodId) {
      return this.client.delete("/v3/billing-methods/".concat(billingMethodId)).then(this._data);
    }
  }, {
    key: "addPayoutMethod",
    value: function addPayoutMethod(data) {
      return this.client.post("/v3/payout-methods", data).then(this._data);
    }
  }, {
    key: "removePayoutMethod",
    value: function removePayoutMethod(payoutMethodId) {
      return this.client.delete("/v3/payout-methods/".concat(payoutMethodId)).then(this._data);
    }
  }, {
    key: "charge",
    value: function charge(data) {
      return this.client.post("/v3/charges", data).then(this._data);
    }
  }, {
    key: "updateBillingMethod",
    value: function updateBillingMethod(billingMethodId, data) {
      return this.client.patch("/v3/billing-methods/".concat(billingMethodId), data).then(this._data);
    }
  }, {
    key: "depositCredit",
    value: function depositCredit(billingMethodId, data) {
      return this.client.post("/v3/billing-methods/".concat(billingMethodId, "/deposit"), data).then(this._data);
    }
  }, {
    key: "adjustCredit",
    value: function adjustCredit(billingMethodId, data) {
      return this.client.post("/v3/billing-methods/".concat(billingMethodId, "/adjust"), data).then(this._data);
    }
  }, {
    key: "getTransactions",
    value: function getTransactions(billingMethodId) {
      return this.client.get("/v3/billing-methods/".concat(billingMethodId, "/transactions")).then(this._data);
    }
  }, {
    key: "getTransactionsByIds",
    value: function getTransactionsByIds(ids) {
      return this.client.post("/v3/transactions/id-query", {
        ids: ids
      }).then(this._data);
    }
  }]);
}(APIClient);
export var UserCouponAPI = /*#__PURE__*/function (_APIClient3) {
  function UserCouponAPI() {
    _classCallCheck(this, UserCouponAPI);
    return _callSuper(this, UserCouponAPI, arguments);
  }
  _inherits(UserCouponAPI, _APIClient3);
  return _createClass(UserCouponAPI, [{
    key: "getCouponsForUser",
    value: function getCouponsForUser(workspaceId, userId) {
      return this.client.get("/v3/workspaces/".concat(workspaceId, "/users/").concat(userId, "/coupons")).then(this._data);
    }
  }, {
    key: "getClaimsForCoupon",
    value: function getClaimsForCoupon(_ref2) {
      var workspaceId = _ref2.workspaceId,
        couponId = _ref2.couponId,
        query = _objectWithoutProperties(_ref2, _excluded2);
      return this.client.get("/v3/workspaces/".concat(workspaceId, "/coupons/").concat(couponId, "/claims"), {
        params: query
      }).then(this._data);
    }
  }, {
    key: "addCouponToUser",
    value: function addCouponToUser(code, idParams) {
      return this.client.post("/v3/workspaces/".concat(idParams.workspace_id, "/users/").concat(idParams.user_id, "/coupons/").concat(code)).then(this._data);
    }
  }, {
    key: "addDiscountToUser",
    value: function addDiscountToUser(userId, data) {
      return this.client.post("/v3/users/".concat(userId, "/discounts"), data).then(this._data);
    }
  }, {
    key: "redeemCoupon",
    value: function redeemCoupon(userId, couponId) {
      return this.client.post("/v3/users/".concat(userId, "/coupons/").concat(couponId, "/redeem")).then(this._data);
    }
  }]);
}(APIClient);
//# sourceMappingURL=API.js.map
